var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_919_18111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2145 3.4466L12.8259 2.05796C12.0936 1.32573 10.9064 1.32573 10.1742 2.05796L8.78556 3.4466H6.82173C5.78619 3.4466 4.94673 4.28607 4.94673 5.3216V7.28544L3.55809 8.67408C2.82585 9.40631 2.82585 10.5935 3.55809 11.3257L4.94673 12.7144V14.6782C4.94673 15.7137 5.78619 16.5532 6.82173 16.5532H8.78556L10.1742 17.9418C10.9064 18.6741 12.0936 18.6741 12.8259 17.9418L14.2145 16.5532H16.1783C17.2139 16.5532 18.0533 15.7137 18.0533 14.6782V12.7144L19.442 11.3257C20.1742 10.5935 20.1742 9.40631 19.442 8.67408L18.0533 7.28544V5.3216C18.0533 4.28607 17.2139 3.4466 16.1783 3.4466H14.2145ZM13.5137 4.51355C13.6309 4.63076 13.7899 4.6966 13.9556 4.6966H16.1783C16.5235 4.6966 16.8033 4.97643 16.8033 5.3216V7.54432C16.8033 7.71008 16.8692 7.86905 16.9864 7.98626L18.5581 9.55796C18.8022 9.80204 18.8022 10.1978 18.5581 10.4418L16.9864 12.0135C16.8692 12.1308 16.8033 12.2897 16.8033 12.4555V14.6782C16.8033 15.0234 16.5235 15.3032 16.1783 15.3032H13.9556C13.7898 15.3032 13.6309 15.3691 13.5137 15.4863L11.942 17.058C11.6979 17.302 11.3022 17.302 11.0581 17.058L9.48639 15.4863C9.36918 15.3691 9.21021 15.3032 9.04445 15.3032H6.82173C6.47655 15.3032 6.19673 15.0234 6.19673 14.6782V12.4555C6.19673 12.2897 6.13088 12.1308 6.01367 12.0135L4.44197 10.4418C4.19789 10.1978 4.19789 9.80204 4.44197 9.55796L6.01367 7.98626C6.13088 7.86905 6.19673 7.71008 6.19673 7.54432V5.3216C6.19673 4.97643 6.47655 4.6966 6.82173 4.6966H9.04445C9.21021 4.6966 9.36918 4.63076 9.48639 4.51355L11.0581 2.94185C11.3022 2.69777 11.6979 2.69777 11.942 2.94185L13.5137 4.51355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9555 4.6966C13.7897 4.6966 13.6308 4.63076 13.5135 4.51355L11.9418 2.94185C11.6978 2.69777 11.302 2.69777 11.058 2.94185L9.48626 4.51355C9.36905 4.63076 9.21008 4.6966 9.04432 4.6966H6.8216C6.47643 4.6966 6.1966 4.97643 6.1966 5.3216V7.54432C6.1966 7.71008 6.13076 7.86905 6.01355 7.98626L4.44185 9.55796C4.19777 9.80204 4.19777 10.1978 4.44185 10.4418L6.01355 12.0135C6.13076 12.1308 6.1966 12.2897 6.1966 12.4555V14.6782C6.1966 15.0234 6.47643 15.3032 6.8216 15.3032H9.04432C9.21008 15.3032 9.36905 15.3691 9.48626 15.4863L11.058 17.058C11.302 17.302 11.6978 17.302 11.9418 17.058L13.5135 15.4863C13.6308 15.3691 13.7897 15.3032 13.9555 15.3032H16.1782C16.5234 15.3032 16.8032 15.0234 16.8032 14.6782V12.4555C16.8032 12.2897 16.8691 12.1308 16.9863 12.0135L18.558 10.4418C18.802 10.1978 18.802 9.80204 18.558 9.55796L16.9863 7.98626C16.8691 7.86905 16.8032 7.71008 16.8032 7.54432V5.3216C16.8032 4.97643 16.5234 4.6966 16.1782 4.6966H13.9555Z",
    fill: "#35B9E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8585 8.35849L10.6666 12.5504L8.55798 10.4418L9.44187 9.55794L10.6666 10.7827L13.9747 7.47461L14.8585 8.35849Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_919_18111",
    x: -1,
    y: -1.25,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_919_18111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_919_18111",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberprofile);
export default __webpack_public_path__ + "static/media/memberprofile.82e8052a4590579175fed038f9d74b9b.svg";
export { ForwardRef as ReactComponent };